import React from 'react';
import TestWizard from '../components/TestWizard/TestWizard';

export default function Execute() {
	return <TestWizard />;
}




